import { Text, Box, Group } from "@mantine/core";
import { ProcessStep } from "../../services/logService";

export function SlipDetectionContent({ log }: { log: ProcessStep }) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const details = (log.details as any) || {};
  const detectedType = details.slipType;
  const source = details.source; // "ai" | "default" など

  return (
    <Box mt={4}>
      <Text
        size="xs"
        c={log.status === "error" ? "red" : "inherit"}
        style={{ whiteSpace: "pre-line" }}
      >
        {log.description}
      </Text>

      {detectedType && (
        <Box
          mt="xs"
          p="xs"
          bg="var(--mantine-color-default)"
          style={{
            borderRadius: "6px",
            border: "1px solid var(--mantine-color-default-border)",
          }}
        >
          <Group align="center" gap="sm">
            <Box style={{ flex: 1, minWidth: 0 }}>
              <Text size="10px" c="dimmed" mb={2}>
                検出された伝票種別
              </Text>
              <Box
                h={28}
                px="xs"
                bg="var(--mantine-color-violet-light)"
                style={{
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  color: "var(--mantine-color-violet-light-color)",
                }}
              >
                <Text
                  size="xs"
                  fw={700}
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {detectedType}
                </Text>
              </Box>
            </Box>
            {source && (
              <Text size="10px" c="dimmed">
                判定: {source}
              </Text>
            )}
          </Group>
        </Box>
      )}
    </Box>
  );
}
